import {Moment} from 'moment';
import {ICustomer} from './customer.model';
import {ITransaction} from './transaction.model';
import {IFileObject} from "./file-object.model";
import {IOrganization} from "./organization.model";
import {IPhone} from "./phone.model";
import {IKala} from "./kala.model";
import {IEmployee} from "./employee.model";
import {IFactorItems} from "./factorItems.model";
import {IProject} from "./project.model";
import {ISupplier} from "./supplier.model";

export interface IFactor {
  id?: number;
  title?: string;
  type?: string;
  startDate?: Moment;
  customer?: ICustomer;
  supplier?: ISupplier;
  project?: IProject;
  itemName?: string;
  code?: string;
  address?: string;
  audience?: string;

  audience_phone?: string;
  phone?: IPhone;
  status?: string;
  stock_status?: string;
  phone_id?: string;
  strDateObject?: any;
  porsant?: any;
  step?: string;
  taxation?: string;
  discount?: string;
  total_sum?: any;
  factor_number?: string;
  factor_amount?: string;
  pre_factor_amount?: any;
  pre_factor_supplier_amount?: any;
  factor_supplier_amount?: any;
  factor_amount_number?: number;
  factor_supplier_amount_total_number?: number;
  factor_amount_total_number?: number;
  factor_type?: string;
  factor_payment_method?: string;
  store_number?: string;
  store_responsible?: string;
  send_method?: string;
  employee_str?: any;
  payment_description?: string;
  payment_method?: string;
  address_receiver?: string;
  send_bill_number?: string;
  factor_date?: string;
  pre_factor_date?: string;
  supplier_assign_date?: string;
  factor_date_str?: string;
  lastModifiedDate?: any;
  last_modified_date?: any;
  created_date?: any;

  updateDate?: string;
  description?: string;
  createdDate?: any;
  createdBy?: string;
  lastModifiedBy?: string;
  transactions?: ITransaction[];
  files?: IFileObject[];
  factorItems?: IFactorItems[];
  employee?: IEmployee;
  organization?: IOrganization;

}

export class Factor implements IFactor {
  constructor(public id?: number,
              public title?: string,
              public step?: string,
              public description?: string,
              public factor_number?: string,
              public factor_amount?: string,
              public factor_amount_number?: number,
              public factor_type?: string,
              public startDate?: Moment,
              public customer?: ICustomer,
              public supplier?: ISupplier,
              public project?: IProject,
              public phone?: IPhone,
              public createdBy?: string,
              public lastModifiedBy?: string,
              public closed?: boolean,
              public taxation?: any,
              public total_sum?: any,
              public discount?: any,
              public lastModifiedDate?: any,
              public transactions?: ITransaction[],
              public kala?: IKala[],
              public createdDate?: any) {
    this.total_sum = 0;
    this.factor_amount_number = 0;
  }
}
